var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 202,
    viewBox: "0 0 200 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_466_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.233 124.701C21.7853 116.834 13.7734 105.061 13.7734 87.4509C13.7734 60.3746 29.0038 45.1443 56.0801 45.1443L56.6055 45.1461C62.5374 24.8761 79.0429 13.7725 104.185 13.7725C134.827 13.7725 152.642 30.2669 154.118 59.7481C174.683 60.1069 186.228 71.9717 186.228 92.816C186.228 104.951 182.142 114.001 175.699 120.749",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6758 45.167C71.2978 45.167 85.2691 55.4638 89.6763 64.8712",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.634 186.227C121.53 182.587 67.8779 182.587 13.7734 186.227",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.614 106.38C130.534 106.38 136.212 108.732 140.399 112.918C144.584 117.104 146.936 122.782 146.936 128.702C146.936 134.623 144.584 140.301 140.399 144.486C125.647 159.238 78.0917 154.341 69.1936 154.341C60.2955 154.341 13.7734 151.025 13.7734 151.025",
    stroke: "#0B1D2E",
    strokeWidth: 14.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_466_15",
    x: -4,
    y: 0,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_466_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_466_15",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreath);
export default __webpack_public_path__ + "static/media/breath.5cdc29ac0c3b7abb706b205dafe87827.svg";
export { ForwardRef as ReactComponent };